if (!customElements.get("read-more")) {
  customElements.define(
    "read-more",
    class ReadMore extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll(".read-more__button");
        this.content = document.querySelector("#drop-desc");

        if (!this.buttons[0] || !this.content) return;

        Array.from(this.buttons).forEach((button) => {
          button.addEventListener("click", this._handleButtonClick.bind(this));
        });
      }

      _handleButtonClick(e) {
        //open up the drop down as the hrref anchores the scroll down
        var is_open = this.content.querySelector("details[open]");
        if (!is_open) {
          this.content.querySelector("summary").click();
        }
      }
    },
  );
}

